import styled from "styled-components";
import {
  Loading,
  LoadingIcon
} from "@streeteasy/design-system/deprecated/Loading/styled";

import { ContactBoxContents } from "src/shared/contact-boxes/components/ContactBox/styled";

import { ContactBox } from "../ContactBox/styled";

export const LoadingContactBox = styled(ContactBox)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 560px;

  ${ContactBoxContents} {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;

    ${Loading} {
      padding: 15px;

      ${LoadingIcon} {
        font-size: 35px;
      }
    }
  }
`;
